import { createSelector } from 'reselect';
import { mapWithDefault } from '../../../utils/dataMapper';

const selectRentalVehicleExcessSCTIStep = (state) => state.get('rentalVehicleExcessSCTIStep');

const makeSelectRentalVehicleExcessSCTIStep = () => createSelector(
  selectRentalVehicleExcessSCTIStep,
  (RentalVehicleExcessSCTIStepState) => ({
    infoRentalVehicleExcessItems: mapWithDefault(RentalVehicleExcessSCTIStepState, () => RentalVehicleExcessSCTIStepState.getIn(['form', 'infoRentalVehicleExcessItems']) && RentalVehicleExcessSCTIStepState.getIn(['form', 'infoRentalVehicleExcessItems']).toJS(), ''),
  })
);

const makeSelectRentalVehicleExcessSCTIStepErrors = () =>
  createSelector(selectRentalVehicleExcessSCTIStep, (state) => state.get('errors'));

export {
  makeSelectRentalVehicleExcessSCTIStep,
  makeSelectRentalVehicleExcessSCTIStepErrors,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.SCTI.RentalVehicleExcess/selectors.js